import React from 'react';
import { authPages, othersMenu, publicPages } from '../menu';
import Footer from '../layout/Footer/Footer';

const footers = [
  // { path: layoutMenu.blank.path, element: null, exact: true },
  { path: authPages.login.path, element: null, exact: true },
  { path: othersMenu.monitor_login.path, element: null, exact: true },
  { path: othersMenu.resetPassword.path, element: null, exact: true },
  { path: authPages.signUp.path, element: null, exact: true },
  { path: authPages.page404.path, element: null, exact: true },
  { path: othersMenu.orderMonitor.path, element: null, exact: true },
  { path: publicPages.evaluation.path, element: null, exact: true },
  { path: publicPages.clientRegister.path, element: null, exact: true },
  { path: '*', element: <Footer /> },
];

export default footers;
